<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Deleted Coupons</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-coupons' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="coupons.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(coupon, index) in filteredCoupons" :key="index">
                  <th scope="row">{{ coupon.id }}</th>
                  <td>{{ coupon.name }}</td>
                  <td>{{ coupon.code }}</td>
                  <td>{{ coupon.expires_at }}</td>
                  <!-- <td>{{ coupon.type }}</td> -->
                  <td>{{ coupon.available == 1 ? 'True' : 'False' }}</td>

                  <td>
                    <button class="me-2 btn btn-success" @click="restoreCoupon(coupon.id)">
                      Restore
                    </button>

                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No deleted coupons found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
export default {
  name: "DeletedCoupons",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      coupons: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name', key: 'name' },
        { label: 'Code', key: 'code' },
        { label: 'Expiration', key: 'expires_at' },
        // { label: 'Type', key: 'type' },
        { label: 'Availablilty', key: 'available' },
      ],
    };
  },

  async created() {
    this.fetchCoupons();
  },

  computed: {
    filteredCoupons() {
      if (!this.searchTerm) {
        return this.coupons;
      }
      const term = this.searchTerm.toLowerCase();
      return this.coupons.filter(
        (coupon) =>
          coupon.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch orders
    async fetchCoupons() {
      try {
        const response = await axios.get(
          `/admin/admin/coupon/get-delete-soft`
        );
        this.coupons = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching coupon:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    restoreCoupon(id) {
      console.log("restore coupon id: ", id);
      axios
        .post(`/admin/admin/coupon/restore?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchCoupons();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>